(function () {
  'use strict';

  var BUST_TO_SIZE = {
    '32': 'XXS', '34': 'XS', '36': 'S', '38': 'M', '40': 'L', '42': 'XL',
    '44': '2XL', '46': '3XL', '48': '4XL', '50': '5XL', '52': '6XL'
  };

  function sizeParts(value) {
    var raw = String(value || '');
    var bustMatch = raw.match(/Bust\s*:\s*(\d+)/i);
    var letterMatch = raw.match(/(?:^|\/\s*)(XXS|XS|S|M|L|XL|[2-6]XL)\s*$/i);
    var bust = bustMatch ? bustMatch[1] : '';
    var letter = letterMatch ? letterMatch[1].toUpperCase() : (BUST_TO_SIZE[bust] || '');
    return { bust: bust, letter: letter };
  }

  function optionCopy(button) {
    var parts = sizeParts(button.getAttribute('data-hok-option-value') || button.textContent);
    if (!parts.bust || !parts.letter) return;
    var tailored = /tailor/i.test(button.textContent || '');
    var title = button.querySelector('.hok-variant-picker__title');
    var meta = button.querySelector('.hok-variant-picker__meta');
    if (title && parts.letter) title.textContent = parts.letter;
    if (meta) meta.textContent = tailored ? 'Bust ' + parts.bust + '\" · Tailoring +$30' : 'Bust ' + parts.bust + '\" · Ready';
    if (!meta && title && parts.bust) {
      meta = document.createElement('span');
      meta.className = 'hok-variant-picker__meta';
      meta.textContent = 'Bust ' + parts.bust + '\" · Ready';
      title.insertAdjacentElement('afterend', meta);
    }
    button.setAttribute('aria-label', (parts.letter || 'Size') + ', bust ' + parts.bust + ' inches, ' + (tailored ? 'tailoring plus 30 dollars' : 'ready to dispatch'));
  }

  function statusBlock(picker) {
    var scope = picker.closest('.add-to-cart-form') || picker.parentElement;
    var blocks = scope.querySelectorAll('.hok-size-choice-status');
    var block = blocks[0];
    Array.prototype.slice.call(blocks, 1).forEach(function (duplicate) { duplicate.remove(); });
    if (!block) {
      block = document.createElement('div');
      block.className = 'hok-size-choice-status';
      block.setAttribute('role', 'status');
      block.setAttribute('aria-live', 'polite');
      picker.insertAdjacentElement('afterend', block);
    }
    return block;
  }

  function setAddButton(button, selected) {
    if (!button) return;
    if (!button.dataset.hokOriginalLabel) button.dataset.hokOriginalLabel = /select a size/i.test(button.textContent) ? 'Add to cart' : (button.textContent.trim() || 'Add to cart');
    button.disabled = !selected;
    button.setAttribute('aria-disabled', selected ? 'false' : 'true');
    button.textContent = selected ? button.dataset.hokOriginalLabel : 'Select a size';
  }

  function updateSelection(picker, option) {
    var parts = sizeParts(option.getAttribute('data-hok-option-value') || option.textContent);
    var tailored = /tailor/i.test(option.textContent || '');
    var triggerTitle = picker.querySelector('[data-hok-selected-title]');
    var triggerMeta = picker.querySelector('[data-hok-selected-meta]');
    if (!parts.bust || !parts.letter) {
      picker.dataset.hokCustomerSelected = 'true';
      var genericStatus = statusBlock(picker);
      genericStatus.className = 'hok-size-choice-status hok-size-choice-status--ready';
      genericStatus.innerHTML = '<strong>Ready to dispatch</strong><span>Dispatches within 1 business day.</span>';
      setAddButton(document.querySelector('button[name="add"], #purchase'), true);
      consolidateStatusBlocks();
      return;
    }
    if (triggerTitle) triggerTitle.textContent = parts.letter || 'Selected size';
    if (triggerMeta) triggerMeta.textContent = 'Bust ' + parts.bust + '\" · ' + (tailored ? 'Tailoring +$30' : 'Ready');

    var block = statusBlock(picker);
    if (tailored) {
      block.className = 'hok-size-choice-status hok-size-choice-status--tailored';
      block.innerHTML = '<strong>Tailoring included</strong><span>We’ll adjust this piece to ' + parts.letter + ' (bust ' + parts.bust + '\"). The displayed price includes the $30 tailoring fee. Please allow up to 5 additional business days for tailoring.</span>';
    } else {
      block.className = 'hok-size-choice-status hok-size-choice-status--ready';
      block.innerHTML = '<strong>Ready to dispatch</strong><span>Dispatches within 1 business day.</span>';
    }

    picker.dataset.hokCustomerSelected = 'true';
    setAddButton(document.querySelector('button[name="add"], #purchase'), true);
    consolidateStatusBlocks();
    window.setTimeout(consolidateStatusBlocks, 250);
    window.setTimeout(consolidateStatusBlocks, 700);
  }

  function resetPickerPlaceholder(picker) {
    if (picker.dataset.hokCustomerSelected === 'true') return;
    var triggerTitle = picker.querySelector('[data-hok-selected-title]');
    var triggerMeta = picker.querySelector('[data-hok-selected-meta]');
    if (triggerTitle) triggerTitle.textContent = 'Choose a size';
    if (triggerMeta) triggerMeta.textContent = 'See ready and tailored options';
    picker.querySelectorAll('.hok-variant-picker__option').forEach(function (option) {
      option.classList.remove('is-selected');
      option.setAttribute('aria-checked', 'false');
    });
  }

  function enhanceProductPicker() {
    var picker = document.querySelector('[data-hok-variant-picker]');
    if (!picker || picker.dataset.hokSimplified === 'true') return;
    picker.dataset.hokSimplified = 'true';

    document.querySelectorAll('.hok-variant-picker-native-hidden').forEach(function (el) {
      el.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('.hok-tailoring-notice').forEach(function (el) {
      el.hidden = true;
      el.setAttribute('aria-hidden', 'true');
    });

    var options = Array.prototype.slice.call(picker.querySelectorAll('.hok-variant-picker__option'));
    if (!options.length) return;
    var isBustSizing = options.some(function(option) { return /Bust\s*:/i.test(option.getAttribute('data-hok-option-value') || ''); });
    options.forEach(optionCopy);

    resetPickerPlaceholder(picker);
    options.forEach(function (option) {
      option.classList.remove('is-selected');
      option.setAttribute('aria-checked', 'false');
      option.addEventListener('click', function () {
        updateSelection(picker, option);
      });
    });

    var guide = picker.parentElement.querySelector('[data-hok-size-guide-open]');
    if (guide) guide.textContent = 'Find my size';
    statusBlock(picker).innerHTML = '';
    setAddButton(document.querySelector('button[name="add"], #purchase'), false);
    window.setTimeout(function () { resetPickerPlaceholder(picker); }, 100);
    window.setTimeout(function () { resetPickerPlaceholder(picker); }, 600);
  }

  function enhanceSizeGuide() {
    document.querySelectorAll('.hok-size-guide-modal').forEach(function (modal) {
      if (modal.dataset.hokSimplified === 'true') return;
      if (modal.dataset.chartType === 'menswear') return;
      modal.dataset.hokSimplified = 'true';
      var table = modal.querySelector('.hok-size-table--matrix');
      if (!table) return;

      var intro = document.createElement('div');
      intro.className = 'hok-simple-size-guide';
      intro.innerHTML = '<p class="hok-simple-size-guide__lead"><strong>Start with your bust.</strong> Choose the letter size whose bust measurement is closest to yours. If you are between sizes, choose the larger size or ask us for help.</p><div class="hok-simple-size-guide__grid" role="list"></div><p class="hok-simple-size-guide__note">AU equivalents are a reference only. Your bust measurement is the best starting point for these garments.</p>';
      var grid = intro.querySelector('.hok-simple-size-guide__grid');
      var au = {'32':'AU 2','34':'AU 4','36':'AU 6','38':'AU 8','40':'AU 10','42':'AU 12','44':'AU 14','46':'AU 16','48':'AU 18','50':'AU 20','52':'AU 22'};
      Object.keys(BUST_TO_SIZE).forEach(function (bust) {
        var card = document.createElement('div');
        card.className = 'hok-simple-size-guide__card';
        card.setAttribute('role', 'listitem');
        card.innerHTML = '<strong>' + BUST_TO_SIZE[bust] + '</strong><span>Bust ' + bust + '\"</span><small>' + au[bust] + ' equivalent</small>';
        grid.appendChild(card);
      });

      var details = document.createElement('details');
      details.className = 'hok-size-guide-details';
      details.innerHTML = '<summary>View full garment measurements</summary>';
      table.parentNode.insertBefore(intro, table);
      table.parentNode.insertBefore(details, table);
      details.appendChild(table);
    });
  }

  function enhanceCollectionCards(root) {
    (root || document).querySelectorAll('[data-hok-card-quick]').forEach(function (quick) {
      if (quick.dataset.hokSimplified === 'true') return;
      var json = quick.querySelector('[data-hok-card-variants]');
      var article = quick.closest('.indiv-product');
      var link = article && article.querySelector('.indiv-product__link');
      if (!json || !link) return;
      var variants;
      try { variants = JSON.parse(json.textContent); } catch (error) { return; }
      if (!variants.some(function(variant) { return /Bust\s*:/i.test(variant.label || ''); })) return;
      var ready = variants.filter(function (variant) { return variant.available && !variant.tailored; });
      var labels = ready.map(function (variant) { return sizeParts(variant.label).letter; }).filter(Boolean);
      quick.className = 'hok-card-ready';
      quick.innerHTML = '<p class="hok-card-ready__sizes"><strong>Ready sizes:</strong> ' + (labels.length ? labels.join(', ') : 'Check availability') + '</p><p class="hok-card-ready__note">More sizes may be available with tailoring.</p><a class="hok-card-ready__link" href="' + link.getAttribute('href') + '">View details</a>';
    });
  }

  function updateCartCopy(root) {
    (root || document).querySelectorAll('.hok-cart-tailoring-meta, [data-hok-tailoring-meta]').forEach(function (meta) {
      meta.remove();
    });

    (root || document).querySelectorAll('form[action*="/cart"] .cart__meta-text, #cartSlideoutWrapper .cart-item-variant-title').forEach(function (element) {
      var match = (element.textContent || '').trim().match(/^(?:Size\s*:\s*)?AU\s*\d+\s*\/\s*Bust\s*:\s*(\d+)\"?\s*\/\s*(XXS|XS|S|M|L|XL|[2-6]XL)$/i);
      if (!match) return;
      var prefix = element.classList.contains('cart__meta-text') ? 'Size: ' : '';
      element.textContent = prefix + match[2].toUpperCase() + ' · Bust ' + match[1] + '"';
      element.dataset.hokSimpleSize = 'true';
    });

    var cartForm = document.querySelector('form[action*="/cart"]');
    if (false && cartForm && !cartForm.querySelector('.hok-cart-returns-note')) {
      var checkout = cartForm.querySelector('#cart_submit, [name="checkout"]');
      var note = document.createElement('p');
      note.className = 'hok-cart-returns-note';
      note.textContent = 'Eligible for exchange or store credit within 7 days. Tailoring fees are non-refundable.';
      if (checkout && checkout.parentElement) checkout.parentElement.insertAdjacentElement('beforebegin', note);
      else cartForm.appendChild(note);
    }
  }

  document.addEventListener('hok:cart-rendered', function() { updateCartCopy(document); });

  function consolidateStatusBlocks() {
    var blocks = Array.prototype.slice.call(document.querySelectorAll('.template-product .hok-size-choice-status'));
    if (blocks.length < 2) return;
    var preferred = blocks.filter(function (block) {
      return block.classList.contains('hok-size-choice-status--tailored') || block.classList.contains('hok-size-choice-status--ready');
    })[0] || blocks[0];
    blocks.forEach(function (block) { if (block !== preferred) block.remove(); });
  }

  function run(root) {
    enhanceProductPicker();
    enhanceSizeGuide();
    enhanceCollectionCards(root || document);
    updateCartCopy(root || document);
    consolidateStatusBlocks();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(document); });
  else run(document);

  // Bounded, coalesced updates prevent observer-triggered rendering loops.
  var pending = false;
  var observer = new MutationObserver(function(mutations) {
    if (pending || !mutations.some(function(m){return Array.from(m.addedNodes).some(function(n){return n.nodeType === 1 && (n.matches && n.matches('collection-filtering-form, .product-grid, .cart-drawer, #cartSlideoutWrapper'));});})) return;
    pending = true;
    window.setTimeout(function(){ pending = false; observer.disconnect(); try { run(document); } finally { observer.observe(document.body, {childList:true,subtree:true}); } }, 200);
  });
  if (document.body) observer.observe(document.body, {childList:true,subtree:true});
})();

